import { createHashRouter, Navigate, RouterProvider, useRouteError } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { ErrorState } from "@/components/ui/States";
import { Dashboard } from "@/modules/dashboard/Dashboard";
import { WarehouseMap } from "@/modules/map/WarehouseMap";
import { Map3D } from "@/modules/map3d/Map3D";
import { ReportView } from "@/modules/reports/ReportView";
import { AbcXyzView } from "@/modules/reports/AbcXyzView";
import { QualityReports } from "@/modules/reports/QualityReports";
import { StaffKpi } from "@/modules/reports/StaffKpi";
import { Blocks } from "@/modules/blocks/Blocks";
import { LicensePlates } from "@/modules/lp/LicensePlates";
import { Counts } from "@/modules/counts/Counts";
import { Journal } from "@/modules/journal/Journal";
import { Decisions } from "@/modules/decisions/Decisions";
import { Skus } from "@/modules/skus/Skus";
import { Imports } from "@/modules/imports/Imports";
import { Integration } from "@/modules/integration/Integration";
import { Reconciliation } from "@/modules/integration/Reconciliation";
import { Orders } from "@/modules/orders/Orders";
import { Tasks } from "@/modules/tasks/Tasks";
import { TaskHistory } from "@/modules/tasks/TaskHistory";
import { Topology } from "@/modules/topology/Topology";
import { ReceivingSessions } from "@/modules/receiving/ReceivingSessions";
import { Notifications } from "@/modules/notifications/Notifications";
import { Audit } from "@/modules/audit/Audit";
import { Settings } from "@/modules/settings/Settings";
import { Backup } from "@/modules/backup/Backup";
import { Security } from "@/modules/security/Security";
import { NAV_ITEMS } from "./navigation";


/**
 * Modul ichidagi kutilmagan xato BUTUN ilovani oq ekranga
 * aylantirmasligi kerak: yon panel joyida qoladi, xato faqat
 * modul o'rnida chiqadi va xodim boshqa bo'limga o'ta oladi.
 */
function ModuleError() {
  const error = useRouteError();
  return <ErrorState error={error} onRetry={() => window.location.reload()} />;
}

function hintFor(path: string): string {
  return NAV_ITEMS.find((item) => item.path === path)?.hint ?? "";
}

/**
 * Hash-router ATAYLAB: Electron sahifani `file://` orqali
 * yuklaydi va u yerda brauzer tarixiga asoslangan yo'llar
 * ishlamaydi — yangilashda 404 bo'lardi.
 */
const router = createHashRouter([
  {
    path: "/",
    element: <AppShell />,
    children: [
      {
        errorElement: <ModuleError />,
        children: [
          { index: true, element: <Dashboard /> },
          {
            path: "stock",
            element: (
              <ReportView
                report="stock"
                title="Qoldiq"
                hint={hintFor("/stock")}
                supportsIssuesFilter
              />
            ),
          },
          { path: "topology", element: <Topology /> },
          { path: "tasks", element: <Tasks /> },
          { path: "task-history", element: <TaskHistory /> },
          { path: "quality", element: <QualityReports /> },
          { path: "orders", element: <Orders /> },
          // Eski 1C prixod/qaytarish sahifalari olib tashlandi (2026-11-01):
          // saqlangan havolalar erkin sessiya sahifalariga olib boradi.
          { path: "receipts", element: <Navigate to="/receiving-sessions" replace /> },
          { path: "returns", element: <Navigate to="/return-sessions" replace /> },
          { path: "receiving-sessions", element: <ReceivingSessions kind="RECEIPT" /> },
          { path: "return-sessions", element: <ReceivingSessions kind="RETURN" /> },
          { path: "decisions", element: <Decisions /> },
          { path: "skus", element: <Skus /> },
          { path: "imports", element: <Imports /> },
          { path: "integration", element: <Integration /> },
          { path: "reconciliation", element: <Reconciliation hint={hintFor("/reconciliation")} /> },
          {
            path: "discrepancies",
            element: (
              <ReportView
                report="discrepancies"
                title="Tafovutlar"
                hint={hintFor("/discrepancies")}
                supportsIssuesFilter
              />
            ),
          },
          {
            path: "reports",
            element: <StaffKpi hint={hintFor("/reports")} />,
          },
          { path: "abc-xyz", element: <AbcXyzView hint={hintFor("/abc-xyz")} /> },
          { path: "map", element: <WarehouseMap /> },
          { path: "map-3d", element: <Map3D /> },
          { path: "pallets", element: <LicensePlates /> },
          { path: "blocks", element: <Blocks /> },
          { path: "counts", element: <Counts /> },
          { path: "journal", element: <Journal /> },
          { path: "notifications", element: <Notifications /> },
          { path: "audit", element: <Audit /> },
          { path: "settings", element: <Settings /> },
          { path: "backup", element: <Backup /> },
          { path: "security", element: <Security /> },
          { path: "*", element: <Navigate to="/" replace /> },
        ],
      },
    ],
  },
]);

export function Router() {
  return <RouterProvider router={router} />;
}
